import { Link } from "@tanstack/react-router";
import { motion } from "motion/react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { finalCta } from "../lib/landingData";
import { HolographicCard } from "../components/HolographicCard";

export function FinalCtaSection() {
  return (
    <section id="metrics" className="py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <HolographicCard className="p-1">
            <div className="relative rounded-xl bg-background/60 p-8 sm:p-16 text-center overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-primary/20 rounded-full blur-[100px] -z-10" />

              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary/30 bg-primary/10 text-primary text-sm font-medium mb-6">
                <Sparkles className="h-4 w-4" />
                Early access
              </div>

              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-foreground mb-4">
                {finalCta.headline}
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-10">
                {finalCta.subheadline}
              </p>

              <Button asChild size="lg" className="group">
                <Link to={finalCta.ctaHref}>
                  {finalCta.cta}
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </HolographicCard>
        </motion.div>
      </div>
    </section>
  );
}
